import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useRef, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import logo from "../../assets/Icon/Logollc.png";
import Button from "./Button";
import ContactModal from "./ContactModal";
import "./Header.css";

const menus = {
  Commercial: {
    cols: 1,
    items: [
      { label: "Commercial Roofing", href: "/commercial-roofing" },
      { label: "Free Roof Inspections & Estimates", href: "/contact" },
      { label: "Roof Replacement", href: "/contact" },
      { label: "Roof Installation", href: "/contact" },
      { label: "Roof Repair & Maintenance", href: "/contact" },
      { label: "Emergency Roofing Services", href: "/contact" },
      { label: "Roof Tarping", href: "/contact" },
      { label: "TPO Roof", href: "/contact" },
      { label: "Metal Roof", href: "/contact" },
      { label: "Shingles Roof", href: "/contact" },
      { label: "Tile Roof", href: "/contact" },
    ],
    cta: { label: "Commercial Services", href: "/commercial-roofing" },
  },
  Residential: {
    cols: 1,
    items: [
      { label: "Residential Roofing", href: "/residential-roofing" },
      { label: "Free Roof Inspections & Estimates", href: "/contact" },
      { label: "Roof Replacement", href: "/contact" },
      { label: "Roof Installation", href: "/contact" },
      { label: "Roof Repair & Maintenance", href: "/contact" },
      { label: "Emergency Roofing Services", href: "/contact" },
      { label: "Roof Tarping", href: "/contact" },
      { label: "Metal Roof", href: "/contact" },
      { label: "Shingles Roof", href: "/contact" },
      { label: "Tile Roof", href: "/contact" },
    ],
    cta: { label: "Residential Services", href: "/residential-roofing" },
  },
  Others: {
    cols: 1,
    items: [
      { label: "Siding Enhancements", href: "/siding-enhancements" },
      { label: "Gutter Systems", href: "/gutter-systems" },
      { label: "Window Services", href: "/window-services" },
      { label: "Power wash", href: "/our-team" },
      { label: "Painting", href: "/our-team" },
      { label: "Flooring", href: "/our-team" },
      { label: "Interior and Exterior Renovation", href: "/our-team" },
    ],
    cta: { label: "Others", href: "/siding-enhancements" },
  },
  "Service Area": {
    cols: 3,
    items: [
      { label: "Columbus, Ohio", href: "location/columbus-ohio" },
      { label: "Dublin, Ohio", href: "location/dublin-ohio" },
      { label: "Hilliard, Ohio", href: "location/hilliard-ohio" },
      { label: "Powell, Ohio", href: "location/powell-ohio" },
      { label: "Marysville, Ohio", href: "location/marysville-ohio" },
      { label: "Reynoldsburg, Ohio", href: "location/reynoldsburg-ohio" },
      { label: "Blacklick, Ohio", href: "location/blacklick-ohio" },
      { label: "Gahanna, Ohio", href: "location/gahanna-ohio" },
      { label: "Delaware, Ohio", href: "location/delaware-ohio" },
    ],
    cta: { label: "Service Area", href: "/service-area/columbus" },
  },
  Company: {
    cols: 1,
    items: [
      { label: "About", href: "/about" },
      { label: "Our Team", href: "/our-team" },
      { label: "Projects", href: "/projects" },
      { label: "Reviews", href: "/reviews" },
      { label: "Career With Us", href: "/success-page" },
    ],
    cta: { label: "Company", href: "/about" },
  },
};

function chunk(items, cols) {
  const per = Math.ceil(items.length / cols);
  const chunks = [];
  for (let i = 0; i < cols; i++) {
    chunks.push(items.slice(i * per, i * per + per));
  }
  return chunks;
}

export default function Header() {
  const [expanded, setExpanded] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const isMobile = window.innerWidth <= 1024;
  const timeoutRef = useRef(null);

  // Google Ads phone call conversion tracking
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'AW-16886781189/H9gUCIrokLQcEIWqn_Q-', {
        phone_conversion_number: '+16143577539',
      });
    }
  }, []);

  return (
    <Navbar
      collapseOnSelect
      expand="xl"
      sticky="top"
      className="irs-navbar py-3 fontHauora"
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container fluid className="custom-container">
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
          <img src={logo} alt="IRS Logo" className="logoImg" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="irs-nav" />
        <Navbar.Collapse id="irs-nav" className="scrollMobileNav">
          <Nav className="mx-auto irs-nav">
            {Object.entries(menus).map(([menuLabel, { items, cols, cta }]) => {
              const columns = chunk(items, cols);

              return (
                <NavDropdown
                  key={menuLabel}
                  title={menuLabel}
                  id={`${menuLabel.toLowerCase().replace(/\s+/g, "-")}-dd`}
                  menuClassName={`mega-menu cols-${isMobile ? 12 : cols} ${activeDropdown === menuLabel ? "show" : ""}`}
                  show={activeDropdown === menuLabel}
                  onMouseEnter={() => {
                    if (!isMobile) {
                      clearTimeout(timeoutRef.current);
                      setActiveDropdown(menuLabel);
                    }
                  }}
                  onMouseLeave={() => {
                    if (!isMobile) {
                      timeoutRef.current = setTimeout(() => {
                        setActiveDropdown(null);
                      }, 200); // Delay in ms
                    }
                  }}
                  onClick={() => {
                    if (isMobile) {
                      setActiveDropdown(
                        activeDropdown === menuLabel ? null : menuLabel,
                      );
                    }
                  }}
                >
                  {!isMobile && <div className="dropdown-arrow" />}
                  <div className="mega-content">
                    {columns.map((col, i) => (
                      <div className="mega-col" key={i}>
                        {col.map((item) => (
                          <NavDropdown.Item
                            as={Link}
                            to={item.href}
                            key={item.label}
                            className="mega-item bg-white"
                            onClick={() => {
                              setExpanded(false);
                              setActiveDropdown(null);
                            }}
                          >
                            <IoIosArrowForward className="mega-dropdown-item-icon" />
                            <span className="item-text">{item.label}</span>
                          </NavDropdown.Item>
                        ))}
                      </div>
                    ))}
                  </div>

                  {/* CTA button with dropdown close on click */}
                  <Button
                    buttonText={cta.label}
                    buttonType="nav"
                    href={cta.href}
                    as={Link}
                    to={cta.href}
                    onClick={() => {
                      setExpanded(false);
                      setActiveDropdown(null); // Close dropdown
                    }}
                  />
                </NavDropdown>
              );
            })}

            <div className="center-btn">
              <Nav.Link
                as={Link}
                to="/contact"
                className="contact"
                onClick={() => setExpanded(false)}
              >
                Contact
              </Nav.Link>
            </div>
          </Nav>

          <div className="center-btn">
            <ContactModal />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
